import React, { useEffect, useState } from "react";
import { useLoading } from "../LoadingContext";

function Preloader() {
  const { loading, setLoading } = useLoading();
  const [fadeOut, setFadeOut] = useState(false);
  const [render, setRender] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);

  const loadingSteps = [
    "Welcome to GSMI",
    "Loading resources...",
    "Preparing your experience...",
    "Ready!"
  ];

  useEffect(() => {
    setLoading(true);
    
    // Progressive loading steps
    const stepInterval = setInterval(() => {
      setCurrentStep(prev => {
        if (prev < loadingSteps.length - 1) {
          return prev + 1;
        }
        clearInterval(stepInterval);
        return prev;
      });
    }, 700);

    // Hide preloader after 3 seconds
    const timer = setTimeout(() => {
      setLoading(false);
      setFadeOut(true);
    }, 3000);

    // Remove preloader completely
    const removePreloader = setTimeout(() => {
      setRender(false);
    }, 4000);

    return () => {
      clearInterval(stepInterval);
      clearTimeout(timer);
      clearTimeout(removePreloader);
    };
  }, [setLoading, loadingSteps.length]);

  useEffect(() => {
    if (loading) {
      document.body.classList.add("loading-active");
      document.documentElement.classList.add("loading-active");
    } else {
      document.body.classList.remove("loading-active");
      document.documentElement.classList.remove("loading-active");
    }
  }, [loading]);

  // Calculate progress percentage
  const progressPercentage = Math.min(
    ((currentStep + 1) / loadingSteps.length) * 100,
    100
  );

  return (
    render && (
      <div id="preloader" className="page-preloader">
        <div className={`preloader-container ${fadeOut ? "fade-out" : ""}`}>
          <div className="logo-container">
            <img
              src={require("../assets/images/logo-gsmi.svg").default || require("../assets/images/logo-gsmi.svg")}
              alt="GSMI Logo"
              className="logo"
            />
          </div>
          
          <div className="loading-text">
            <span className="loading-message">
              {loadingSteps[currentStep]}
            </span>
            
            <div className="loading-progress">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ width: `${progressPercentage}%` }}
                />
              </div>
              <span className="progress-text">
                {Math.round(progressPercentage)}%
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default Preloader;
